import html2pdf from 'html2pdf.js';
import html2canvas from 'html2canvas';
import JsPDF, { jsPDFOptions } from 'jspdf';
import imageSrc from '@/assets/cascade_event_system_logo.jpg';
import i18n from '@/i18n';
import '@/lib/font/Jost-Regular-normal';
import { Sheet, SheetWithItems } from '@/model/Sheet';

export function newnewPdf(sheet: SheetWithItems | Sheet): void {
    const element = document.getElementById('pdf-canvas');
    if (element) {
        const htmlRatio = element.offsetWidth / element.offsetHeight;

        const margin = 23;

        const docWidth = 297;
        const docHeight = 210;

        const canvasOpts = {
            dpi: 600,
            scale: 2,
            width: element.offsetWidth,
            height: element.offsetHeight,
        };
        const jsPDFOpts = {
            orientation: 'landscape',
            unit: 'mm',
            format: [docWidth, docHeight],
        };

        html2canvas(element, canvasOpts).then((canvas) => {
            const pdf = new JsPDF(jsPDFOpts as jsPDFOptions);
            pdf.setFont('Jost-Regular');

            const img = new Image();
            img.src = imageSrc;
            const imgWidthMM = 18;
            const imgHeighthMM = imgWidthMM / 1.03;
            const imageMargin = 5;
            pdf.addImage(
                img,
                'JPEG',
                docWidth - imageMargin - imgWidthMM,
                imageMargin,
                imgWidthMM,
                imgHeighthMM,
            );

            pdf.setFontSize(12);
            pdf.text(i18n.t('sheet.pdf.creator').toString(), 17, 20, {
                align: 'left',
                angle: -90,
            });
            pdf.text(i18n.t('sheet.pdf.administrator').toString(), 12, 20, {
                align: 'left',
                angle: -90,
            });
            if (sheet.name && sheet.eventName) {
                pdf.text(
                    i18n
                        .t('sheet.pdf.sheet-event', {
                            sheetName: sheet.name,
                            eventName: sheet.eventName,
                        })
                        .toString(),
                    7,
                    20,
                    {
                        align: 'left',
                        angle: -90,
                    },
                );
            }

            pdf.setFontSize(10);
            pdf.text('1', docWidth - imageMargin, docHeight - imageMargin, {
                align: 'right',
            });

            // EVENTFLOW

            pdf.addImage(
                canvas.toDataURL('image/jpeg'),
                'JPEG',
                margin,
                margin,
                docWidth - 2 * margin,
                (docWidth - 2 * margin) / htmlRatio,
            );
            const pages = Math.ceil(
                (docWidth - 2 * margin + margin) / htmlRatio / docHeight,
            );
            for (let i = 1; i < pages; i += 1) {
                pdf.addPage();

                pdf.addImage(
                    img,
                    'JPEG',
                    docWidth - imageMargin - imgWidthMM,
                    imageMargin,
                    imgWidthMM,
                    imgHeighthMM,
                );

                pdf.setFontSize(12);
                pdf.text(i18n.t('sheet.pdf.creator').toString(), 17, 20, {
                    align: 'left',
                    angle: -90,
                });
                pdf.text(i18n.t('sheet.pdf.administrator').toString(), 12, 20, {
                    align: 'left',
                    angle: -90,
                });
                if (sheet.name && sheet.eventName) {
                    pdf.text(
                        i18n
                            .t('sheet.pdf.sheet-event', {
                                sheetName: sheet.name,
                                eventName: sheet.eventName,
                            })
                            .toString(),
                        7,
                        20,
                        {
                            align: 'left',
                            angle: -90,
                        },
                    );
                }

                pdf.setFontSize(10);
                pdf.text(
                    `${i + 1}`,
                    docWidth - imageMargin,
                    docHeight - imageMargin,
                    {
                        align: 'right',
                    },
                );

                pdf.addImage(
                    canvas.toDataURL('image/jpeg'),
                    'JPEG',
                    margin,
                    docHeight * -i + margin,
                    docWidth - 2 * margin,
                    (docWidth - 2 * margin) / htmlRatio,
                );
            }
            pdf.save(`Cascade - ${sheet.name}.pdf`);
        });
    }
}

export async function newPdf(): Promise<void> {
    const eventFlow = document.getElementById('grid');
    if (eventFlow) {
        const docWidth = 297;
        const docHeight = 210;
        const eventFlowAspRatio =
            eventFlow.offsetWidth / eventFlow.offsetHeight;

        const html2eventFlowCanvasOpts = {
            dpi: 600,
            scale: 2,
            height: eventFlow.offsetHeight,
            width: eventFlow.offsetWidth,
        };

        const jsPDFOpts = {
            orientation: 'landscape',
            unit: 'mm',
            format: [docWidth, docHeight],
        };

        const margin = 20;

        const eventFlowCanvas = await html2canvas(
            eventFlow,
            html2eventFlowCanvasOpts,
        );
        const pdf = new JsPDF(jsPDFOpts as jsPDFOptions);
        const eventFlowCanvasImageStartX = margin;
        const eventFlowCanvasImageStartY = margin;
        const eventFlowCanvasImageHeight = docHeight - 2 * margin;
        const eventFlowCanvasImageWidth =
            eventFlowCanvasImageHeight * eventFlowAspRatio <
            docWidth - 2 * margin
                ? eventFlowCanvasImageHeight * eventFlowAspRatio
                : docWidth - 2 * margin;
        pdf.addImage(
            eventFlowCanvas.toDataURL('image/jpeg'),
            'JPEG',
            eventFlowCanvasImageStartX,
            eventFlowCanvasImageStartY,
            eventFlowCanvasImageWidth,
            eventFlowCanvasImageHeight,
        );
        const img = new Image();
        img.src = '/img/cascade_logo.3d01d331.jpg';
        pdf.addImage(img, 'jpg', 10, 10, 16, 12.6);
        pdf.setFontSize(20);
        /* pdf.text(`${this.getCurrentSheetWithItems?.name}`, docWidth / 2, 10, {
            align: 'center',
            baseline: 'top',
        }); */
        pdf.save('jsPDF.pdf');
    }
}

// Ez a verzio mukodik a legjobban jelenleg, viszont a kep szelesseget szetnyujtja, tehat ha nincs annyi sav, akkor hezagok lesznek a savok kozott.
export function createHtml2pdf(): void {
    const element = document.getElementById('grid');

    const opt = {
        filename: 'myfile.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        margin: 20,
        html2canvas: {
            scale: 3,
            dpi: 600,
        },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' },
    };
    html2pdf().from(element).set(opt).save();
}

// Ez a verzio mukodik a legjobban jelenleg, viszont a kep szelesseget szetnyujtja, tehat ha nincs annyi sav, akkor hezagok lesznek a savok kozott.
export function createHtml2pdf2222(): void {
    const element = document.getElementById('grid');

    const opt = {
        filename: 'myfile.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        margin: 10,
        html2canvas: {
            scale: 1,
            dpi: 200,
        },
        jsPDF: {
            unit: 'pt',
            // format: [element?.offsetWidth, element!.offsetWidth / 1.5],
            orientation: 'landscape',
        },
    };
    html2pdf().from(element).set(opt).save();
}

// ez a verzio nem nyujtja szet, viszont levag darabokat, meg nem jottem ra mitol. (valoszinuleg rosszul szamolja ki, hogy hol vagja el a pageket)
export function createHtml(): void {
    html2canvas(document.getElementById('grid') as HTMLElement).then(
        (canvas) => {
            const contentWidth = canvas.width;
            const contentHeight = canvas.height;
            const pageHeight = 841.89;
            let leftHeight = contentHeight;
            let position = 0;
            const imgWidth = 595.28;
            const imgHeight = (592.28 / contentWidth) * contentHeight;
            const pageData = canvas.toDataURL('image/jpeg', 1.0);
            const pdf = new JsPDF('l', 'pt', 'a4');
            if (leftHeight < pageHeight) {
                pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
            } else {
                while (leftHeight > 0) {
                    pdf.addImage(
                        pageData,
                        'JPEG',
                        0,
                        position,
                        imgWidth,
                        imgHeight,
                    );
                    leftHeight -= pageHeight;
                    position -= 841.89;
                    if (leftHeight > 0) {
                        pdf.addPage();
                    }
                }
            }
            pdf.save('content.pdf');
        },
    );
}
